
var mapper = {};

export default {
  register(eventName, handler) {
    let eventHandlers = mapper[eventName];
    if (eventHandlers == null) {
      eventHandlers = [];
      mapper[eventName] = eventHandlers;
    }
    eventHandlers.push(handler);
  },
  fire(eventName, params) {
    let eventHandlers = mapper[eventName];
    if (eventHandlers == null) {
      return;
    }
    eventHandlers.forEach((handler) => {
      handler(params);
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/open/common/EventEmitter.js